import { render, staticRenderFns } from "./Wxpay.vue?vue&type=template&id=bd7dd22a&scoped=true&"
import script from "./Wxpay.vue?vue&type=script&lang=js&"
export * from "./Wxpay.vue?vue&type=script&lang=js&"
import style0 from "./Wxpay.vue?vue&type=style&index=0&id=bd7dd22a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7dd22a",
  null
  
)

export default component.exports